<template>
    <section id="content">
        <div v-if="selectedProduct.video_mobile && selectedProduct.image_video_mobile" class="d-lg-none">
            <product-video-component data-env="mobile" :data-video-url="this.selectedProduct.video_mobile" :data-image-url="this.selectedProduct.image_video_mobile"></product-video-component>
        </div>
        <div class="py-0 overflow-visible">
            <div class="row g-0">
                <div class="col-xxl-9 col-xl-8 col-lg-7">
                    <div class="masonry-thumbs grid-container row row-cols-2 row-cols-lg-1"
                        data-lightbox="gallery">
                        <a :href="_.first(selectedProduct.images)" data-lightbox="gallery-item">
                            <picture>
                                <source media="(max-width: 768px)"
                                    :srcset="imageSmall(_.first(selectedProduct.images))">
                                <img class="w-100" :src="_.first(selectedProduct.images)"
                                    :alt="selectedProduct.name + ' image #1'">
                            </picture>
                        </a>
                        <div  v-if="selectedProduct.video_desktop && selectedProduct.image_video_desktop" class="d-none d-lg-block">
                               <product-video-component :data-video-url="this.selectedProduct.video_desktop" :data-image-url="this.selectedProduct.image_video_desktop"></product-video-component>
                        </div>
                        <a v-for="(image, index) in _.slice(selectedProduct.images, 1)" :key="index" :href="image"
                            data-lightbox="gallery-item">
                            <picture>
                                <source media="(max-width: 768px)" :srcset="imageSmall(image)">
                                <img class="w-100" :src="image" :alt="selectedProduct.name + ' image #' + (index + 2)">
                            </picture>
                        </a>
                    </div>
                </div>
                <div class="col-xxl-3 col-xl-4 col-lg-5 pt-5 pt-md-0 position-lg-sticky h-100 top-0">
                    <div class="p-md-5 px-3">
                        <!-- <p class="text-uppercase ls-2 mb-3 small">Serum <span class="mx-2">/</span> <span
                            class="op-07 ls-1">1.7fl oz - 50ml</span></p> -->
                        <!-- <p class="text-uppercase ls-2 mb-3 small">{{ selectedProduct.category.name }}</p> -->
                        <div class="d-flex align-items-center mb-3">
                            <h2 class="lh-sm mb-0">{{ selectedProduct.name }} </h2>
                            <div v-if="config.modules.wishlist" class="ms-3">
                                <span class="cursor-pointer" @click="toggleToWishlist">
                                    <span v-if="this.wishlist.find((product) => product.id == this.selectedProduct.id)">
                                        <i class="fas fa-heart"></i>
                                    </span>
                                    <span v-else>
                                        <i class="far fa-heart"></i>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <!-- <h3 class="lh-sm mb-5">{{ amountWithCurrency(selectedProduct.price) }}</h3> -->

                        <h3 class="lh-sm mb-0" v-if="selectedProduct">
                            <div v-if="selectedProduct.discount_price">
                                <span class="h6 text-decoration-line-through me-2 ">
                                    {{ amountWithCurrency(selectedProduct.public_price) }}
                                </span>
                                <span class="h5 red-text">
                                    {{ amountWithCurrency(selectedProduct.discount_price) }}
                                </span>
                            </div>
                            <div class="h5 red-text" v-else-if="selectedProduct.price">
                                {{ amountWithCurrency(selectedProduct.price) }}
                            </div>
                        </h3>

                        <!-- <a href="#" class="button m-0 button-black" style="--cnvs-btn-padding-y: 0.75rem"><i
                                class="uil uil-shopping-cart me-3"></i>Add to Shopping Cart</a> -->

                        <!-- <button :disabled="!selectedProduct.canBeOrdered" class="button mt-3 mt-lg-0 button-black ms-0"
                            @click="addToCart">
                            {{ t.product.add_to_cart }}
                        </button> -->

                        <a v-if="selectedProduct.slug == 'super-e'"
                        href="https://www.kickstarter.com/projects/martoni/super-e-the-micro-mobility-device-that-flies"
                        target="_blank" class="button mt-3 mt-lg-0 button-black ms-0">
                            Check on Kickstarter
                        </a>

                        <a v-if="selectedProduct.slug == 'cardio-speeder'"
                        href="https://www.kickstarter.com/projects/martoni/martoni-cardio-speeder-no-pain-all-gain"
                        target="_blank" class="button mt-3 mt-lg-0 button-black ms-0">
                            Check on Kickstarter
                        </a>

                        <div class="pt-3" v-if="avgRate">
                            <i class="fa-solid fa-star fa-sm"></i> {{ avgRate }}/{{ config.reviews.rate_max_value }}
                            <span class="text-muted text-lowercase">({{ reviewsCount }} {{ t.reviews.reviews }})</span>
                            <a href="#" class="btn btn-link" data-bs-toggle="modal" data-bs-target="#reviewsModal">
                                More
                            </a>
                        </div>

                        <div class="small pt-2" v-if="config.modules.stock && selectedProduct.stock !== null && selectedProduct.stock <= 0">
                            <i class="fa-solid fa-triangle-exclamation"></i> {{ settings.order_out_of_stock ?
                                t.product.restocking : t.product.out_of_stock }}
                        </div>
                        <div class="small pt-2"
                            v-else-if="config.modules.stock && !settings.order_out_of_stock && selectedProduct.stock && selectedProduct.stock <= settings.low_stock">
                            <i class="fa-solid fa-triangle-exclamation"></i> {{ this.__('product', 'low_stock', {
                                'stock':
                                    selectedProduct.stock
                            }) }}
                        </div>

                        <!-- <small v-if="settings.shipping_limit_free" class="d-block mt-3 op-06"><i>*Free delivery for
                                purchases over {{ amountWithCurrency(settings.shipping_limit_free) }}</i></small> -->

                        <div class="toggle mb-0 mt-5 toggle-active" data-state="open">
                            <div class="toggle-header flex-row-reverse">
                                <div class="toggle-icon">
                                    <i class="toggle-closed fa-solid fa-chevron-right"></i>
                                    <i class="toggle-open fa-solid fa-chevron-down"></i>
                                </div>
                                <div class="toggle-title">
                                    Overview
                                </div>
                            </div>
                            <div class="toggle-content">
                                <div v-html="selectedProduct.description"></div>
                            </div>
                        </div>

                        <!-- <div v-if="selectedProduct.attributeValues.length" class="line my-3"></div>
                        <div v-if="selectedProduct.attributeValues.length" class="toggle mb-0">
                            <div class="toggle-header flex-row-reverse">
                                <div class="toggle-icon">
                                    <i class="toggle-closed fa-solid fa-chevron-right"></i>
                                    <i class="toggle-open fa-solid fa-chevron-down"></i>
                                </div>
                                <div class="toggle-title">
                                    Features
                                </div>
                            </div>
                            <div class="toggle-content">
                                <div class="tab-pane" id="attribute" role="tabpanel" aria-labelledby="attribute-tab">
                                    <div v-for="(attribute, index) in selectedProduct.attributeValues" :key="index"
                                        class="row" :class="{ 'bg-light': index % 2 }">
                                        <div class="col fw-bold py-2">{{ attribute.name }}</div>
                                        <div class="col py-2">
                                            <span v-if="attribute.type == 'numeric'">{{ attribute.numeric_value }}{{
                                                attribute.unitName }}</span>
                                            <span v-else-if="attribute.type == 'boolean'">{{ attribute.boolean_value ?
                                                t.global.yes :
                                                t.global.no }}</span>
                                            <span v-else>
                                                <span v-for="value in attribute.values" :key="value.id">{{ value.name
                                                }}{{ attribute.unitName }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="line my-3"></div>

                        <div class="toggle mb-0">
                            <div class="toggle-header flex-row-reverse">
                                <div class="toggle-icon">
                                    <i class="toggle-closed fa-solid fa-chevron-right"></i>
                                    <i class="toggle-open fa-solid fa-chevron-down"></i>
                                </div>
                                <div class="toggle-title">
                                    Features
                                </div>
                            </div>
                            <div class="toggle-content" v-html="selectedProduct.features"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Modal -->
        <div class="modal fade" id="reviewsModal" tabindex="-1" aria-labelledby="reviewsModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="reviewsModalLabel">Customer Reviews</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="config.modules.reviews">
                            <reviews-component :productId="selectedProduct.id"></reviews-component>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loaded && selectedProduct.bundles && selectedProduct.bundles.length" class="mt-5">
            <div class="container">
                <div class="h5">{{ t.bundles.bundle_offers }}</div>
                <div class="row">
                    <div v-for="bundle in selectedProduct.bundles" :key="bundle.id" class="col-12 col-md-6">
                        <bundle-block-component :data-bundle="bundle"></bundle-block-component>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedProduct.highlights && selectedProduct.highlights.length">
            <div class="container mt-lg-6 mt-5">
                <div class="row align-items-stretch">
                    <div class="mb-4"
                        :class="{ 'col-xl-12': highlight.size == 'large', 'col-xl-6': highlight.size == 'medium' }"
                        v-for="(highlight, index) in selectedProduct.highlights" :key="index">
                        <div class="d-flex position-relative bg-contrast-100 flex-column overflow-hidden">
                            <div class="row ms-0">
                                <div v-if="highlight.image" class="col-12 col-xl ps-0">
                                    <img :src="highlight.image" class="w-100">
                                </div>
                                <div class="d-flex align-items-center col-12"
                                    :class="{ 'col-xl-5': highlight.size == 'large', 'col-xl-6': highlight.size == 'medium' }">
                                    <div class="p-3 p-md-4">
                                        <h2 class="h5">{{ highlight.title }}</h2>
                                        <div v-html="highlight.text"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrap container" v-if="selectedProduct.testimonials && selectedProduct.testimonials.length">
            <!-- <div class="row justify-content-center">
                <div class="block-testimonials card py-4 no-border">
                    <div id="oc-testi" class="owl-carousel testimonials-carousel carousel-widget" data-margin="0"
                        data-items="1" data-loop="true" data-autoplay="true" data-autoplay-timeout="10000"
                        data-nav="false" data-dots="true">
                        <div class="oc-item" v-for="(testimonial, index) in selectedProduct.testimonials" :key="index">
                            <div class="row g-0 align-items-center">
                                <div class="col-md-4 d-flex flex-column text-center align-items-center">
                                    <h4 class="mb-0 text-primary">{{ testimonial.name }}</h4>
                                    <h5 class="mb-0 fw-normal">{{ testimonial.title }}</h5>
                                </div>
                                <div class="col-md-8 p-4 testi-content lead fst-italic"
                                    v-html="nl2br(testimonial.quote)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div id="testimonial-carousel" class="owl-carousel carousel-widget" data-items="1" data-items-lg="2"
                data-stage-padding="0" data-pagi="false">
                <div class="oc-item" v-for="(testimonial, index) in selectedProduct.testimonials" :key="index">
                    <div class="card" data-animate="fadeInRightSmall">
                        <div class="card-body p-0 ps-1 pe-5">
                            <div class="row">
                                <div class="col-12">
                                    <i class="fa-solid fa-quote-left color fs-2"></i>
                                    <p class="mb-4" v-html="nl2br(testimonial.quote)"></p>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <h4 class="h6 mb-0 fw-medium">{{ testimonial.name }}</h4>
                                        <small class="text-muted">{{ testimonial.title }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-wrap container pt-0" v-show="selectedProduct.faqs && selectedProduct.faqs.length">
            <div v-for="(faq, index) in selectedProduct.faqs" class="toggle py-4 mb-0"
                :class="{ 'border-bottom': index != selectedProduct.faqs.length - 1 }"
                style="--cnvs-toggle-font-size: 1.125rem;">
                <div class="toggle-header align-items-center">
                    <div class="toggle-title fw-semibold">
                        {{ faq.question }}
                    </div>
                    <div class="toggle-icon">
                        <i class="toggle-closed bi-plus-circle fs-4 op-05"></i>
                        <i class="toggle-open bi-dash-circle fs-4"></i>
                    </div>
                </div>
                <div class="toggle-content fs-6" v-html="faq.answer"></div>
            </div>
            <!-- </div> -->
        </div>
    </section><!-- #content end -->
</template>

<script>
import store from "../CartStore";
import ReviewsComponent from './ReviewsComponent.vue';
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

export default {
    store: store,
    components: {
        ReviewsComponent,
    },
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            wishlist: config.modules.wishlist ? wishlist : [],
            product: product,
            variations: variations,
            selectedProduct: selectedProduct ? selectedProduct : product,
            qty: 1,
            image360Position: 0,
        };
    },
    computed: {
        ...Vuex.mapGetters(['loaded', 'cart']),
        canOrder() {
            if (config.modules.stock && !settings.order_out_of_stock && this.selectedProduct.stock <= 0) {
                return false
            }
            return true
        },
        avgRate() {
            return this.product.avgRate
        },
        reviewsCount() {
            return this.product.reviewsCount
        }
    },
    methods: {
        ...Vuex.mapActions(['addProduct', 'updateProduct', 'addBundle']),
        addToCart() {
            var productToAddToCart = this.product
            if (this.variations && this.variations.length) {
                productToAddToCart = this.selectedProduct;
            }
            productToAddToCart.qty = this.qty
            this.addProduct(productToAddToCart);
        },
        selectProduct() {
            this.image360Position = 0
            this.changeUrl()
        },
        changeUrl() {
            history.replaceState(
                {},
                null,
                this.url('product/' + this.selectedProduct.slug)
            )
        },
        toggleToWishlist() {
            axios
                .post("/ajax/wishlist/toggleToWishlist", {
                    id: this.selectedProduct.id
                })
                .catch((error) => { Vue.notify({ text: error.message, type: 'error' }) })
                .then((response) => {
                    Vue.notify({ text: response.data.message.text, type: response.data.message.type })
                    this.wishlist = response.data.wishlist
                    this.$root.$emit("updateWishlist", response.data.wishlist);
                });
        },
    },
};
</script>
